<!-- <mat-expansion-panel class="mb-2" (opened)="panelOpenState = true" (closed)="panelOpenState = false">
  <mat-expansion-panel-header>
    <mat-panel-title>
    Información sobre los controles para dibujar la finca.
    </mat-panel-title>
  <mat-panel-description>
  </mat-panel-description>
  </mat-expansion-panel-header>
  <p>Seleccionando en el dibujo del polígono se cambia el cursor para poder dibujar la finca en cuestión.</p>
  <p>Una vez dibujada la finca, podremos editar la finca si lo deseamos con el siguiente boton.</p>
  <p>En el último botón podemos borrar la finca dibujada para volver a empezar.</p>
</mat-expansion-panel> -->

<div class="map2-container">
    <div class="map2-frame">
      <div id="map2">
      </div>
    </div>
</div>
